import React, { useState } from 'react'
import { STATICS } from 'statics'
import { useFirebaseEvent, useToaster } from 'hooks'
import {
  BILLS_PAYMENT_TYPE,
  BILLS_TAGS,
  DOWNLOAD_PAID_BILL_MESSAGE,
  FIREBASE_EVENTS,
  GET_PAYMENT_URL_ERROR_MESSAGE,
} from 'app-constants'
import { formatCurrenctyWithoutSignal, formatDate, getTagInfo, isBefore } from 'utils'
import { Button, PaymentButton, RecurringPayment, InvoiceTag, BillsDownload } from 'components'
import { financialService } from 'services'
import { LABELS, LABELS_KEYS } from '../../constants'
import './style.scss'

export function FinancialLine({
  dueDate,
  urlFile,
  isPaymentRecurring,
  id,
  index,
  value,
  downloadButtonText,
  isInvoice,
  isPaid,
  tags = [],
  paymentDate,
  isMobile = false,
  detailedInvoiceUrl = '',
  paymentType,
}) {
  const [isLoadingPaidBill, setIsLoadingPaidBill] = useState(false)

  const { sendEvent } = useFirebaseEvent()
  const { showErrorToast } = useToaster()
  const { getPaidBillDownloadLink } = financialService()

  async function handleDownloadPaidBill() {
    try {
      setIsLoadingPaidBill(true)
      const { data } = await getPaidBillDownloadLink(id)

      if (data.url) window.open(data.url)
      else showErrorToast(DOWNLOAD_PAID_BILL_MESSAGE)
    } catch (error) {
      console.error(error)

      showErrorToast(DOWNLOAD_PAID_BILL_MESSAGE)
    } finally {
      setIsLoadingPaidBill(false)
    }
  }

  function handleDownloadInvoice() {
    sendEvent(FIREBASE_EVENTS.CLICK_DOWNLOAD_BILLETS_LIST)

    window.open(urlFile)
  }

  async function handleDownloadClick() {
    if (isInvoice) handleDownloadInvoice()
    else await handleDownloadPaidBill()
  }

  function handleLinkErrorMessage(error) {
    const errorMessage = error || GET_PAYMENT_URL_ERROR_MESSAGE

    showErrorToast(errorMessage)
  }

  function isValidPaymentRecurring() {
    const isOverdue = isBefore(dueDate, new Date())
    if (paymentType === BILLS_PAYMENT_TYPE.CREDIT_CARD && isOverdue) {
      return false
    }

    return isPaymentRecurring
  }

  function renderTag() {
    const info = getTagInfo(isPaid, isPaymentRecurring, tags, paymentType, dueDate)

    return <InvoiceTag className='tag' tagInfo={info} />
  }

  function renderDownloadButton() {
    return (
      <div className='container-payment-button'>
        <Button
          className='button download'
          icon={<STATICS.DOWNLOAD />}
          color='primary'
          onClick={handleDownloadClick}
          isLoading={isLoadingPaidBill}
        >
          {downloadButtonText}
        </Button>
      </div>
    )
  }

  function renderPaymentButton() {
    return (
      <div className='container-payment-button'>
        <PaymentButton
          invoiceId={id}
          event={FIREBASE_EVENTS.CLICK_ON_PAYMENT_MY_BILLS}
          showErrorMessage={handleLinkErrorMessage}
        />
      </div>
    )
  }

  function renderRecurringPayment() {
    return (
      <div className='container-recurring'>
        <RecurringPayment />
      </div>
    )
  }

  function renderSlipNumber() {
    if (isPaid) return null

    return (
      <div className='container-info number'>
        {renderLabel(LABELS_KEYS.NUMBER)}
        <span className='text'>{id}</span>
      </div>
    )
  }

  function renderPaymentDate() {
    if (!paymentDate) return null

    return (
      <div className='container-info payment-date'>
        {renderLabel(LABELS_KEYS.PAYMENT_DATE)}
        <span className='text'>{formatDate(paymentDate)}</span>
      </div>
    )
  }

  function renderAction() {
    if (isPaid) return renderDownloadButton()

    const isInNegotiation = tags.includes(BILLS_TAGS.IN_NEGOTIATION)

    if (isInNegotiation) return null

    if (isValidPaymentRecurring()) return renderRecurringPayment()

    return renderPaymentButton()
  }

  function renderLabel(labelKey) {
    const isFirst = index === 0
    const shouldRenderLabel = isFirst || isMobile

    if (!shouldRenderLabel) return null

    const label = LABELS[labelKey]
    const labelText = isMobile ? label.mobile : label.desktop

    return <span className='label'>{labelText}</span>
  }

  function renderBillsDownloadButton() {
    return <BillsDownload tags={tags} url={detailedInvoiceUrl} />
  }

  return (
    <div className='container-open-slip'>
      <div className={`container-infos ${isPaid ? '-paid' : ''}`}>
        {renderSlipNumber()}
        <div className='container-info due-date'>
          {renderLabel(LABELS_KEYS.DUE_DATE)}
          <span className='text'>{formatDate(dueDate)}</span>
        </div>
        <div className='container-info value'>
          {renderLabel(LABELS_KEYS.VALUE)}
          <span className='text'>R$ {formatCurrenctyWithoutSignal(value)}</span>
        </div>
        {renderPaymentDate()}
        <div className='container-info status'>
          {renderLabel(LABELS_KEYS.STATUS)}
          {renderTag()}
        </div>
        <div className='container-info download-details'>{renderBillsDownloadButton()}</div>
        <div className={`container-actions ${isPaid ? '-paid' : ''}`}>{renderAction()}</div>
      </div>
    </div>
  )
}
